export default {
  mainChamber: 'Prehľad pece',
  chamber: 'Komora {subSystemId}',
};
